import { render, staticRenderFns } from "./NotificacaoVisualizar.vue?vue&type=template&id=32bd87ac"
import script from "./NotificacaoVisualizar.vue?vue&type=script&lang=js"
export * from "./NotificacaoVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports